module.exports = __webpack_public_path__ + "static/media/task-sidebar-marked.0ddd9b98.svg";